import { httpApi } from "./http.api";


export const onboarding = (formData: FormData): Promise<any> =>
  httpApi.post<any>("hiring/onboarding/", formData).then(({ data }) => data);

export const onboardingInterviewAnalysis = (formData: FormData): Promise<any> =>
  httpApi.post<any>("report/interview-text-analysis/", formData).then(({ data }) => data);

export const createSearchTemplate = (formData: FormData): Promise<any> =>
    httpApi.post<any>("search/?template=true", formData).then(({ data }) => data);

export const searchTemplates = (template: boolean): Promise<any> =>
  httpApi.get<any>(`search/?template=${template}`).then(({ data }) => data);

export const getAllMeetings = (): Promise<any> =>
  httpApi.get<any>("users/fireflies/fetch-all-meetings/").then(({ data }) => data);

export const getMeetingTranscript = (meetingId: string): Promise<any> =>
  httpApi.get<any[]>(`users/fireflies/get-meeting-transcript/?meeting_id=${meetingId}`).then((data: any) => data.data);

export const setFireFliesAPIKey = (formData: FormData): Promise<any> =>
  httpApi.post<any>("users/fireflies/save-api-key/", formData).then(({ data }) => data);
